import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/biodata-fsp',
    name: 'biodata-fsp',
    component: () => lazyLoadView(import('@views/gtk/biodata/Fsp.vue')),
    meta: {
      title: 'Profil Fasilitator',
    },
  },
  {
    path: '/berkas-tambahan-fsp',
    name: 'berkas-tambahan-fsp',
    component: () => lazyLoadView(import('@views/gtk/berkas/Fsp.vue')),
    meta: {
      title: 'Berkas Dokumen Tambahan',
    },
  },
];
